module.exports = __webpack_public_path__ + "media/music_6.18fbcb56.mp3";